var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolcanoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:url(#radial-gradient-2);}.cls-4{fill:url(#radial-gradient-3);}.cls-5{fill:url(#radial-gradient-4);}.cls-6{fill:url(#radial-gradient-5);}.cls-7{fill:url(#radial-gradient-6);}.cls-8{fill:url(#radial-gradient-7);}.cls-9{fill:url(#radial-gradient-8);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 144.48,
    cy: 95.5,
    r: 34.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#af935e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#c49f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c0995b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ae803f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#a77734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ab7d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#b68e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c7a968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dac786"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 174.2,
    cy: 126.69,
    r: 16.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#af935e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c49f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c0995b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ae803f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#a77734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ab7d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#b68e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c7a968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dac786"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 125.9,
    cy: 127.2,
    r: 13.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#af935e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c49f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c0995b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ae803f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#a77734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ab7d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b68e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c7a968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dac786"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 144.83,
    cy: 149.54,
    r: 20.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#af935e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c49f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#c0995b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ae803f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a77734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ab7d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#b68e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c7a968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#dac786"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 104.47,
    cy: 100.92,
    r: 9.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c49f62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c0995b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ae803f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#a77734"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 185.52,
    cy: 87.71,
    r: 7.54,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 183.92,
    cy: 109.16,
    r: 5.11,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 144.57,
    cy: 67.5,
    r: 4.22,
    xlinkHref: "#radial-gradient-5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.53,145.17a1.36,1.36,0,0,0-2.09-.56c-2.62,2-9.19,5.73-22,5.88-12.57.14-18.3-3.6-20.53-5.71a1.36,1.36,0,0,0-2.15.31c-4.71,8.5-26,46-41.11,55.64-3,2.21-3.65,6.64-.85,8.34s8.39-.55,13-6,8.22,1.7,2.17,8.21-12.55,9.7-9,13.49,16.26-8.64,22.09-18.25c2.13-3.54,5.87-.68,4.08,5.1s-8.8,17.28-4.46,20.47,14.27-6.17,23.15-5.28,10.24,3.1,14.74,7.31,8.2,8.24,13.4,6.39,4.58-3.91,2.45-24.85-3.4-24.25-.94-24.42,1.56,10.17,9.09,21.66,10.6,11.42,13,10.15-4.51-13.47-11.75-33.19-4.51-19.9-3.32-19.9S189.56,215,199,221.28s15.58-1.27,11-6.76-8.93-17-.12-11,15.31,3.19,7.78-3.7C210.29,193.11,179.51,169.64,169.53,145.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.07,131.92s-.77-16.72,13.66-26.42S178.32,93,175.64,90.94s-12.51,11.24-16.47,10.22-5.49-5.36.77-15.58,0-23.1-4.08-17.49.51,28-3.32,29.11S146.41,99,144,84.56s-27.06-32.3-31.15-22.85,18,11.11,23.24,20.55,6,13.92,2.68,17.88-15.07-20.3-24.64-14.43c-1.08.83-2.81,5.15,9.36,11.28S145.17,114.43,148.07,131.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.49,131.92s4.85-14.76,13.19-16.38c7.75-1.5,14.25-.36,12.82,3.83a4.44,4.44,0,0,1-1.26,1.86C176.21,125.76,168.78,117,156.49,131.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.07,127.62s-9.45-21.44-21.45-11.91c-1.11,1.36-1.28,5,10.72,4.74C131.43,120.45,136.07,121.28,140.07,127.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M148.43,138s-14.21-.85-15.4,1.53-4.17,2-4.26,2.89-1.53,4.43,6,4.94,12.51,2.72,18.21.51,1.14-3.84,7.32-3.55,7.15-2.24.34-4.11S154.3,140,148.43,138Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 104.28,
    cy: 101.31,
    r: 5.81
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 185.36,
    cy: 88.03,
    r: 4.81
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 183.81,
    cy: 109.37,
    r: 3.26
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 144.48,
    cy: 67.67,
    r: 2.69
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolcanoIcon);
export default __webpack_public_path__ + "static/media/volcano_icon.179721ba150508c4bc72b795bafd5fa9.svg";
export { ForwardRef as ReactComponent };